<template>
    <b-card :header="caption" v-if="items.length > 0 || loading">
          <div class="center" v-show="loading"><rotate-square  /></div>

      <b-table 
        v-if="!loading && items.length > 0"
        :hover="true"
        sort-icon-left
        responsive="sm" 
        :items="items" 
        :fields="captions" 
        striped
        :per-page="25">
        <template v-slot:cell(acoes)="data" >
            <div class="btn-group-sm"> 
              <b-button  variant="warning"  @click="edit(data.item)" style="margin-right:10px " title="Editar" >
                  <i class="fa fa-edit fa-lg" style="color: black"></i>
              </b-button>
              <b-button v-if="!data.item.possuiLogin && acao"  variant="success"  @click="clickGerarLogin(data.item)" style="margin-right:10px " title="Gerar acesso" >
                  <i class="fa-solid fa-check" style="color: black"></i>
              </b-button>
              <b-button v-if="data.item.possuiLogin" variant="danger"  @click="clicklixeira(data.item)" title="Remover Acesso">
                  <i class="fa-solid fa-xmark" style="color: black"></i>
              </b-button>
            </div>
        </template>
        <template v-slot:cell(cnpj)="data" >
            <span>{{ formatarCNPJ(data.value) }}</span>
        </template>
        <template v-slot:cell(possuiLogin)="data" >
        <div>
          <b-badge :variant="getBadge(data.item.possuiLogin)" title="Gerado usuário de acesso para este cliente?">{{getLogin(data.item.possuiLogin)}}</b-badge>
        </div>
      </template>
      </b-table>
      <nav>
        <b-pagination-nav
          size="md" 
          :number-of-pages="totalDePaginas" 
          v-model="currentPage" 
          :link-gen="linkGen" 
          >
        </b-pagination-nav>
      </nav>
      <b-modal 
        title="Gerar Usuário"
        class="modal-danger" 
        v-model="openModalConfirm" 
        hide-footer>
        
        <b-card>
            <div slot="header">
              <strong>Usuário </strong><small>Edição</small>
            </div>
            <validator prop-name="Email" :erros="erros" campo-descritivo="Usuario/E-mail">
              <b-form-input v-model="Email"
                type="text"
                id="Email"
                slot="component"
                placeholder="Digite o email"></b-form-input>
            </validator>
            <validator prop-name="Senha" :erros="erros" campo-descritivo="Senha">
              <b-form-input v-model="Senha"
                type="password"
                id="Senha"
                slot="component"
                placeholder="Digite a senha"></b-form-input>
            </validator> 
            <b-button  variant="success"  @click="gerarUsuario()" style="margin-right:10px " title="Gerar" >
                <span>Gerar</span>
              </b-button>
          </b-card>
      </b-modal>

          <b-modal 
          title="Remover Acesso"
          class="modal-danger" 
          v-model="openModalDelete" 
          @ok="remove" 
          ok-variant="danger">Você confirma a remoção de acesso desse registro? 
        </b-modal>
  
    </b-card>
  </template>
  <script>
  import {RotateSquare} from 'vue-loading-spinner'
  
  export default {
    name: 'grid-cliente',
    components:{
      RotateSquare,
    },  
    inheritAttrs: false,
    props: {
      caption: {
        type: String,
        default: 'Table'
      },
      tableData: {
        type: [Array, Function],
        default: () => []
      },
      totalDePaginas: {
        type: Number,
        default: 1
      },
      fields: {
          type: [Array, Object],
          default: () => []
      },
      loading:{
        type: Boolean,
        default: true
      },
      acao:{
        type: Boolean,
        default: true
      }
    },
    watch: {
      currentPage(){
        this.$emit("paginacao", this.currentPage )
      }
    },
    created() {
      this.currentPage = parseInt(this.$route.params.id)
    },
    data(){
      return {
        currentPage: 1,
        openModalConfirm: false,
        openModalDelete:false,
        itemCliente: null,
        itemExcluir: null,
        Email: "",
        Senha: "",
        erros:[],
        usuarioDeCadastroId: this.$store.getters.getAutenticacao.usuarioId,
      }
    },
    computed: {
      items() {
        const items =  this.tableData
        return Array.isArray(items) ? items : items()
      },
      captions() { return this.fields },
      UsuarioClienteViewModel(){
        var vm =this
  
        return {
          Id: this.$uuid.v4(),
          ContaId: this.$store.getters.getAutenticacao.contaId,
          Apelido: this.itemCliente.fantasiaCliente,
          UsuarioCadastroId: this.usuarioDeCadastroId,
          Senha: this.Senha,
          Ativo: true,
          AdministradorDaConta: true,
          Email: this.Email,
          Perfil: 3,
          ClienteId: this.itemCliente.id
        }
      }
    },
    methods: {
        formatarCNPJ(cnpj) {
      // Lógica para formatar o CNPJ com a máscara
      const cnpjFormatado = cnpj.replace(
        /^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/,
        "$1.$2.$3/$4-$5"
      );
      return cnpjFormatado;
    },
      getRowCount () {
        return this.items.length
      },
      getBadge (status) {
        return status === true ? 'success' : "danger"
      },
      getLogin (status) {
        return status === true ? "Sim" : "Não"
      },
      edit(obj){
        //console.log(obj.id)
        this.$router.push('/cliente/editar/' + obj.id)
      },
      gerarUsuario(obj){
        var vm = this
        
        this.$http({url: '/usuario/novo', data: this.UsuarioClienteViewModel, method: 'POST'  })
          .then(response => {
            if(!response.data.sucesso){
              vm.erros = response.data.erros
              return
            }
            //this.itemCliente=null
            this.$store.commit("set_mensagem",{tipo: "success", mensagem: "O usuário foi salvo com sucesso!"})
            this.openModalConfirm = false;
            window.location.reload()
        })
        .catch(err => {
            this.$store.commit("set_mensagem",{tipo: "danger", mensagem: err.response.data.errors})
            window.location.reload()
            //this.$router.push('/clientes/1')
        })
      },
      linkGen (pageNum) {
        this.$router.push({ path: `/clientes/${pageNum}` });
      },
      clickGerarLogin(item){
        this.openModalConfirm=true
        this.itemCliente=item
      },
      clicklixeira(item){
        this.openModalDelete=true
        this.itemExcluir=item
      },
      remove(obj){
      this.openModalDelete=false
      this.$emit('table-remove', this.itemExcluir)
      this.itemExcluir=null
    },
    }
  }
  </script>
  